import React, { useState } from "react";
import Swal from "sweetalert2";
import "../assets/css/home_style.css";
import { Link } from "react-router-dom";
import footlogo from "../assets/images/home/logo.png";

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please enter your email address!",
      });
      return;
    }

    const formData = new FormData();
    formData.append("access_key", "a78b83a8-b888-402a-ab79-9aea7f73fbad"); // 🔑 from Web3Forms
    formData.append("email", email);

    // 👇 custom message you will also get in your mail
    formData.append("message", `🎉 New subscriber joined: ${email}`);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Subscribed!",
          text: `🎉 Thank you for subscribing with ${email}`,
          confirmButtonColor: "#0a3d62",
        });
        setEmail(""); // reset input
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Unable to connect. Please check your internet.",
      });
    }
  };

  return (
    <div>
      <section className="email-sec">
        <div className="subscribe-detail">
          <p>
            Subscribe for latest updates
            <div className="long-bar"></div>
          </p>
          <p>Know more about recent happenings at Sanvicasa Group</p>
        </div>
        {/* <div class="subscribe_inner_flex">
          <div class="contact_label subscribe_label">
           
            <label class="input">
              <input class="input__field" type="text" placeholder=" " />
              <span class="input__label">Enter Your Email</span>
            </label>
          </div>

        
          <div class="submit_subscribe_img submit_subscribe_img_arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              stroke="#000000"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </div>
          
        </div> */}
        <form onSubmit={handleSubmit} className="subscribe_inner_flex">
          <div className="contact_label subscribe_label">
            <label className="input">
              <input
                className="input__field"
                type="email"
                name="email"
                placeholder=" "
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <span className="input__label">Enter Your Email</span>
            </label>
          </div>

          <div
            type="submit"
            className="submit_subscribe_img submit_subscribe_img_arrow"
            onClick={handleSubmit}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              stroke="#000000"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </div>
        </form>
      </section>
      <hr />
      <section className="footer">
        <footer>
          <div className="foot-logo">
            <img src={footlogo} alt="Footer-logo" />
            <ul className="address">
              <li>
                'SANVICASA GROUP' Sanvicasa-Saharsh Opp. Solis One,Near Samanvay
                Scintilla, South Bopal, Ahemdabad
              </li>
            </ul>
          </div>
          <ul>
            <li>
              <Link to="">
                <h3> Residential</h3>
              </Link>
            </li>
            <li>
              <Link to="/sparsh">Sanvicasa Sparsh</Link>
            </li>
            <li>
              <Link to="/saharsh">Sanvicasa Saharsh</Link>
            </li>
          </ul>
          <ul>
            <li>
              <Link to="">
                <h3>Quick Links</h3>
              </Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </footer>
      </section>
      <hr />
      <div className="cpy-right">
        {/* <div className="icons">
          <i class="fa-brands fa-instagram"></i>
          <i class="fa-brands fa-facebook"></i>
        </div> */}
        <div className="icons">
          <a
            href="https://www.instagram.com/sanvicasagroup?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-instagram"></i>
          </a>
          <a
            href="https://www.facebook.com/sanvicasagroup"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa-brands fa-facebook"></i>
          </a>
        </div>

        {/* <p>© Sanvicasa Group - 2025</p> */}
        <p>
          © Sanvicasa Group 2025 - {new Date().getFullYear()}
        </p>

      </div>
      <div className="developed-by">
        <p>Developed By : Spigot Infotech</p>
      </div>
    </div>
  );
}
